<template>
    <div>
        <VoteSection @error="error"
            @alert="alert"
            @preload="preload"
            @loaded="loaded"
            :max="1"
            v-bind:title="lang('lbl_0000176')"
            v-bind:notice="lang('lbl_0000185')"
            id="audit"
            category="audit"
            href="/ga/election/vote/elecom/officer"
            color="bg-theme-adcom"
            icon="papsi_selected_audit.svg"
            backable />
    </div>
</template>

<script>
import VoteSection from './../../components/sections/ElectionVoteSection.vue';
import mixin from './../../mixin.js';

export default {
    mixins: [
        mixin,
    ],
    components: {
        VoteSection,
    },
    mounted() {
        this.$emit('checkauth');
        this.$emit('nofooter', true);
        this.$emit('shownavbar', {
            show: false,
        });

        let state = this.$store.state.ga;

        if(!state.registered || state.voted) {
            this.$router.push('/dashboard');
        }
    },
    methods: {
        alert(config) {
            this.$emit('alert', config);
        },
        error(error) {
            this.$emit('error', error);
        },
        preload() {
            this.$emit('showloader');
        },
        loaded() {
            this.$emit('hideloader');
        }
    }
}
</script>